export default {
  data() {
    return {
      shaders: {}
    }
  },
  methods: {
    /**
     * @function getShaderChunks
     * Async call to get the shader chunks based on what is available in the pdm.
     * @returns {Promise} A Promise that resolves when the shader chunks have loaded.
     */
    getShaderChunks() {
      const shadersURL = this.pdm.default_display.shaders_url;
      if (typeof shadersURL === "string") {
        shadersURL = { "default": shadersURL };
      }

      return Promise.all(
        Object.keys(shadersURL)
          .map(shaderName => this.setShaderChunk(shadersURL[shaderName], shaderName))
      );
    },
    /**
     * @function setShaderChunk
     * Async call to get a shader chunk.
     * @param {string} shadersUrl - URL to get shaders.
     * @param {string} shaderName - Name of specific shader.
     * @returns {Promise} A Promise that resolves when a shader chunk have loaded and been assigned.
     */
    setShaderChunk(shadersUrl, shaderName) {
      return this.$store.dispatch("sceneSetup/GET_SHADER_CHUNK", shadersUrl).then(response => {
        this.shaders[shaderName] = this.$model3D.customShaderMaterial.MaterialHelpers.buildShaders(response);
      });
    }
  }
};
